import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=555ad137&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=555ad137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ad137",
  null
  
)

export default component.exports